import PropTypes from "prop-types"
import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"

import Picture from "components/ui/picture"
import { jewlr_t, isTestMode } from "helpers/application"
import { getImgSrcSet } from "helpers/image"
import { cn } from "styles/utils"

const MOBILE_DIM = [650, 324]
const DESKTOP_DIM = [1392, 758]

const slides = [
  {
    desktop: "https://cms.jewlr.com/D_Gif_1_e5b4e91c18/D_Gif_1_e5b4e91c18.jpg",
    mobile: "https://cms.jewlr.com/M_Gif_1_ddcb85154d/M_Gif_1_ddcb85154d.jpg",
  },
  {
    desktop: "https://cms.jewlr.com/D_Gif_2_67b2ffbb2a/D_Gif_2_67b2ffbb2a.jpg",
    mobile: "https://cms.jewlr.com/M_Gif_2_e10ca493bd/M_Gif_2_e10ca493bd.jpg",
  },
  {
    desktop: "https://cms.jewlr.com/D_Gif_3_b06ea1c1af/D_Gif_3_b06ea1c1af.jpg",
    mobile: "https://cms.jewlr.com/M_Gif_3_cd8f94ad1b/M_Gif_3_cd8f94ad1b.jpg",
  },
]

const JewelrySlideshow = ({ element }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const srcSets = useMemo(
    () =>
      slides.map(({ desktop, mobile }) => [
        {
          height: MOBILE_DIM[1],
          media: "(max-width: 1023px)",
          sizes: "(min-width: 768px) 80vw, 90vw",
          srcSet: getImgSrcSet(mobile, MOBILE_DIM[0]),
          width: MOBILE_DIM[0],
        },
        {
          height: DESKTOP_DIM[1],
          media: "(min-width: 1024px)",
          sizes: "(min-width: 1920px) 696px, 40vw",
          srcSet: getImgSrcSet(desktop, DESKTOP_DIM[0]),
          width: DESKTOP_DIM[0],
        },
      ]),
    []
  )

  const handleClick = () => {
    if (!isTestMode) {
      dataLayer.push({
        event: "clicked-personalization-gif",
      })
    }
  }

  useEffect(() => {
    const interval = window.setInterval(() => {
      setCurrentIndex((current) => (current + 1) % slides.length)
    }, 1200)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="widescreen:px-60 desktop:py-20 contained-wide px-16 py-12">
      <div className="desktop:gap-0 desktop:flex-row flex flex-col items-center justify-between gap-24">
        <div className="flex-1">
          <h2 className="text-black-print text-30 tablet:text-54 mobile:text-34 large:text-70 xlarge:text-102 widescreen:text-74 desktop:text-58 tablet:mb-16 mb-8 font-bold leading-none">
            {jewlr_t("terms.Personalized")} {jewlr_t("terms.Jewelry")},<br />
            Thoughtfully Made.
          </h2>
          <p
            className="text-16 tablet:text-18 large:text-20 widescreen:text-24 tablet:max-w-(--tablet-max-width) large:max-w-(--large-max-width) widescreen:max-w-(--widescreen-max-width) leading-20 tablet:leading-[124%] w-9/10 font-medium"
            style={{
              "--large-max-width": "494px",
              "--tablet-max-width": "440px",
              "--widescreen-max-width": "592px",
            }}
          >
            Choose a design, add meaningful details, and we&apos;ll bring it to
            life to celebrate the moments that matter most.
          </p>
        </div>
        <div
          className="desktop:w-4/10 tablet:w-4/5 w-9/10 max-w-(--max-width) relative"
          style={{ "--max-width": "696px" }}
        >
          <Link
            data-lc="personalized-gif"
            onClick={handleClick}
            to="/products/JWL1049/toi-et-moi-oval-and-pear-gemstone-ring"
          >
            {srcSets.map((srcSet, i) => (
              <div
                className={cn(
                  "inset-0",
                  currentIndex === i ? "opacity-100" : "absolute opacity-0"
                )}
                key={`${element.id}-slide-${i}`}
              >
                <Picture
                  alt=""
                  className="h-auto w-full"
                  decoding="async"
                  lazyload={i > 0}
                  srcSet={srcSet}
                />
              </div>
            ))}
          </Link>
        </div>
      </div>
    </div>
  )
}

JewelrySlideshow.propTypes = {
  element: PropTypes.object,
}

export default JewelrySlideshow
